import {
  get,
  post,
  put
} from "./http";
import qs from 'qs'

// 验证码图片
export const getCode = () => {
  let url = "/captchaImage";
  return get(url);
};


// 登录
export const login = (params) => {
  let url = "/loginSynergy";
  return post(url, params);
};

// 系统信息
export const systemInfo = (params) => {
  let url = "/jysk/brain/industrial/index/brain/link";
  return get(url, params);
};

// 获取认证信息
export const autherInfo = (params) => {
  let url = "/jysk/userItem/getUserInfo";
  return get(url, params);
};

// 新增完善信息
export const insertInfo = (params) => {
  let url = "/jysk/userItem/insert";
  return post(url, params);
};

// 修改完善信息
export const updateInfo = (params) => {
  let url = "/jysk/userItem/re-update";
  return post(url, params);
};

// 跳转路由
export const userPath = (params) => {
  let url = "/jysk/synergy/industry/user/path";
  return get(url, params);
};



// 注册
export const register = (params) => {
  let url = "/wan/yuan/authentication";
  return post(url, params);
};

// 发送短信验证码
export const sendMsg = (params) => {
  let url = "/jysk/synergy/industry/sendMsg";
  return get(url, params);
}

// 实名认证
export const realName = (params) => {
  let url = "/manage/user/authentication";
  return post(url, params);
};
// 实名认证信息
export const realNameInfo = (params) => {
  let url = "/manage/user/auth/info";
  return get(url, params);
};

// 个人信息
export const userInfo = (params) => {
  let url = "/getInfo";
  return get(url, params);
};

// 个人信息
export const areaList = (params) => {
  let url = "/wan/yuan/area/list";
  return get(url, params);
};

// 我的项目列表
export const projectList = (params) => {
  let url = "/manage/user/project/list";
  return get(url, params);
};

// 新增项目
export const projectApply = (params) => {
  let url = "/manage/user/project/apply";
  return post(url, params);
};

// 编辑项目
export const projectUpdate = (params) => {
  let url = "/manage/user/project/update";
  return post(url, params);
};

// 项目详情
export const projectDetail = (params) => {
  let url = "/manage/user/project/detail";
  return get(url, params);
};

// 中标列表
export const bidList = (params) => {
  let url = "/manage/user/project/bid/list";
  return get(url, params);
};

// 报名列表
export const applyList = (params) => {
  let url = "/manage/user/project/apply/list";
  return get(url, params);
};

// 公告列表
export const noticeList = (params) => {
  let url = "/wan/yuan/notice/list";
  return get(url, params);
};

// 公告详情
export const noticeDetail = (params) => {
  let url = "/tea/notice/getInfo";
  return get(url, params);
};

// 交易项目列表
export const projectList1 = (params) => {
  let url = "/wan/yuan/project/list";
  return get(url, params);
};

// 项目详情
export const projectDetail1 = (params) => {
  let url = "/wan/yuan/project/detail";
  return get(url, params);
};

// 获取字典
export const getDict = (params) => {
  let url = "/wan/yuan/dict/list";
  return get(url, params);
};


// 竞价项目列表
export const getBidList = (params) => {
  let url = "/wan/yuan/bid/list";
  return get(url, params);
}
// 项目报名
export const projectSign = (params) => {
  let url = "/manage/user/project/sign";
  return post(url, params);
};

// 确认竞价
export const projectBid = (params) => {
  let url = "/manage/user/bid/bid";
  return post(url, params);
};

// 查询文章类型小类数组
export const articleCategory = (params) => {
  let url = "/wan/yuan/getType/" + params.code;
  return get(url, params);
}

//中间分区部分 坐标
export function projectMap(query) {
  let url = "/manage/screen/project/map";
  return get(url, query);
}

// 查询文章列表
export const articleList = (params) => {
  let url = "/wan/yuan/getArticleList/" + params.typeCode + "/" + params.wayCode;
  return get(url, params);
}

// 查询文章详情
export const articleDetail = (params) => {
  let url = "/wan/yuan/getArticleById/" + params.id;
  return get(url, params);
}

// 重新提交报名报名
export const signReply = (params) => {
  let url = "/manage/user/project/sign/reply";
  return post(url, params);
}

// 系统消息通知列表
export const noticeList1 = (params) => {
  let url = "/system/notice/list";
  return get(url, params);
}

// 查看合同详情
export const contractDetail = (params) => {
  let url = "/tea/deal/getInfo/by/projectID";
  return get(url, params);
}

// 修改密码
export const updatePwd = (params) => {
  let url = "/system/user/profile/updatePwd";
  return put(url, params);
}

// 项目审核记录
export const recordList = (params) => {
  let url = "/tea/record/list";
  return get(url, params);
}


// 查询项目展示信息
export const contentDetail = (params) => {
  let url = "/wan/yuan/content/detail";
  return get(url, params);
}

// 项目保证金列表
export const bondList = (params) => {
  let url = "/manage/user/project/bond/list";
  return get(url, params);
}

// 保证金详情
export const bondDetail = (params) => {
  let url = "/manage/user/project/bond/detail";
  return get(url, params);
}

// 修改密码-手机短信方式
export const updatePwdCode = (params) => {
  let url = "/system/user/profile/forgetPwd/code";
  return put(url, params);
}

// 项目报名
export const projectGoSignVerify = (params) => {
  let url = "/manage/user/project/go/sign";
  return get(url, params);
}

// 换绑手机号
export const updatePhone = (params) => {
  let url = "/system/user/profile/update/phone";
  return put(url, params);
}
// 终止项目
export const terminateProject = (params) => {
  let url = "/system/projectBid/terminate/project";
  return put(url, params);
}

// 校验转租
export const checkRent = (params) => {
  let url = "/tea/project/check/rent";
  return get(url, params);
}

// 获取最高出价
export const getHighest = (params) => {
  let url = "/system/projectBid/get/highest";
  return get(url, params);
}

// 我的出价记录
export const bidHistory = (params) => {
  let url = "/system/project_big_log/user/bid/history";
  return get(url, params);
}

// 删除项目
export const deleteProject = (params) => {
  let url = "/tea/project/delete/by/id";
  return get(url, params);
}

// 项目流转记录
export const transferList = (params) => {
  let url = "/tea/project/transfer/list";
  return get(url, params);
}

//流转项目-重新挂牌校验
export const checkReListing = (params) => {
  let url = "/tea/project/check/re/listing";
  return get(url, params);
}